import { disableBodyScroll, enableBodyScroll } from "body-scroll-lock-upgrade";
import gtm from "../utils/GTM";
import { isAboveDesktop } from "../utils/breakpoints";

const Menu = (function () {
  // Classes
  const mainLevelCssClass = "js-menu-item-level-1";
  const level2wrapperCssClass = "main-menu__items__wrapper--level-2";
  const level3wrapperCssClass = "main-menu__items__wrapper--level-3";
  const level3itemsCssClass = "main-menu__items--level-3";
  const activeCssClass = "main-menu__item--active";
  const selectionCssClass = "main-menu__item--selected";
  const headerMenuIsOpen = "menu-is-open";
  const headerSearchIsOpen = "search-is-open";

  // Elements
  const $header = $("header");
  const $navMain = $(".js-navbar-main");
  const $menuWrappers = $(".js-menu-wrapper");
  const $menuItems = $(".js-menu-item");
  const $mobileMenuButton = $(".js-mobile-menu-button");
  const expandSubMenuButtonSelector = ".js-expand-submenu-button";
  const $expandSubMenuButton = $(expandSubMenuButtonSelector);
  const $expandableHeaderBackground = $(".js-expandable-header-background");
  const $searchMain = $(".js-menu-search-wrapper");

  let menuIsOpen = false;
  let useDesktopMenu = isAboveDesktop();
  let menuCloseTimeoutId: number | undefined;

  function init() {
    // $navMain.activateSelectedPath();
    addListeners();
  }

  function addListeners() {
    $header.on("openMenu", openMenu);
    $header.on("closeMenu", restoreAndCloseMenu);

    // Mobile menu toggle
    $mobileMenuButton.on("click", function () {
      if (!menuIsOpen) {
        $header.trigger("openMenu");
      } else {
        $header.trigger("closeMenu");
      }
    });

    // Expand submenu items
    $expandSubMenuButton.on("click", function () {
      const menuItem = $(this).parent().closest($menuItems);

      menuItem.toggle();

      // If this is main menu items, open and close menu when clicking
      if (useDesktopMenu) {
        if (menuItem.hasClass(mainLevelCssClass)) {
          if (menuItem.hasClass(activeCssClass) && !menuIsOpen) {
            $header.trigger("openMenu");
          } else if (!menuItem.hasClass(activeCssClass) && menuIsOpen)
            $header.trigger("closeMenu");

          // If its still open, check if its the selected path, if so activate the children
          if (menuIsOpen && menuItem.hasClass(selectionCssClass))
            $navMain.activateSelectedPath();
        }

        $expandableHeaderBackground.restoreHeight();
      }
    });

    // Toggle on click outside
    $header.on("click", function (e) {
      if (menuIsOpen) {
        if (
          !$(e.target).closest($navMain).length &&
          !$(e.target).closest($mobileMenuButton).length
        ) {
          restoreAndCloseMenu();
        }
      }
    });

    // Handle window resize
    $(window).on("resize", function () {
      changeMobileOrDesktopOnScreenResize();
    });

    // Close menu on focus out
    $navMain.on("focusout", function () {
      // if not setTimeout: async problem
      setTimeout(function () {
        if (!document.activeElement) return;
        const focused = $(document.activeElement);
        if (
          !focused.closest($navMain).length &&
          !focused.is($mobileMenuButton) &&
          !focused.is("body")
        ) {
          restoreAndCloseMenu();
        }
      }, 10);
    });

    $header.on("keydown", function (e: JQuery.KeyDownEvent) {
      if (e.key === "Escape") restoreAndCloseMenu();
    });
  }

  function changeMobileOrDesktopOnScreenResize() {
    const useDesktopMenuBefore = useDesktopMenu;
    useDesktopMenu = isAboveDesktop();
    if (useDesktopMenu !== useDesktopMenuBefore) {
      $header.trigger("closeMenu");
      $menuWrappers.each(function () {
        // Reset the heights:
        $(this).height("");
      });
    }
  }

  // // Function with action on menu (global):
  function openMenu() {
    if (menuCloseTimeoutId !== undefined) {
      window.clearTimeout(menuCloseTimeoutId);
      menuCloseTimeoutId = undefined;
    }

    menuIsOpen = true;

    $header.addClass(headerMenuIsOpen);

    if ($header.hasClass(headerSearchIsOpen) && !useDesktopMenu) {
      $header.trigger("closeSearch");
    }

    if (!useDesktopMenu) {
      if (!$navMain.find("." + activeCssClass).length) {
        $navMain.activateSelectedPath();
      }
      gtm.datalayerPush("menu_open");
    }
    const mainMenu = document.querySelector(".main-menu");
    if (!mainMenu) return;
    disableBodyScroll(mainMenu as HTMLElement, {
      reserveScrollBarGap: true,
    });
  }

  function restoreAndCloseMenu() {
    menuIsOpen = false;

    const mainMenu = document.querySelector(".main-menu");
    if (mainMenu) {
      enableBodyScroll(mainMenu as HTMLElement);
    }

    if (useDesktopMenu) {
      $navMain.closeActiveItems();
      $expandableHeaderBackground.restoreHeight();
    } else {
      gtm.datalayerPush("menu_close");
    }

    menuCloseTimeoutId = window.setTimeout(() => {
      $header.removeClass(headerMenuIsOpen);
      menuCloseTimeoutId = undefined;
    }, 220);
  }

  // Function with action on menuItems:
  $.fn.toggle = function (): JQuery<HTMLElement> {
    if ($(this).hasClass(activeCssClass)) {
      $(this).removeClass(activeCssClass);
      $(this).buttonsCollapsed();
    } else {
      $(this).makeSiblingsAndNephewsInactive();
      $(this).addClass(activeCssClass);
      $(this).buttonsExpanded();
    }
    return $(this);
  };

  $.fn.makeSiblingsAndNephewsInactive = function (): JQuery<HTMLElement> {
    const siblings = $(this)
      .closest("ul")
      .children("." + activeCssClass)
      .not($(this));
    const nephews = siblings.find($menuItems).filter("." + activeCssClass);

    $($.merge(siblings, nephews)).each(function () {
      $(this).removeClass(activeCssClass);
      $(this).buttonsCollapsed();
    });

    return $(this);
  };

  // Function with action on main navigation
  $.fn.activateSelectedPath = function (): JQuery<HTMLElement> {
    return $(this)
      .find($menuItems)
      .filter("." + selectionCssClass)
      .each(function () {
        $(this).addClass(activeCssClass);
        $(this).buttonsExpanded();
      });
  };

  $.fn.closeActiveItems = function (): JQuery<HTMLElement> {
    return $(this)
      .find($menuItems)
      .filter("." + activeCssClass)
      .each(function () {
        $(this).removeClass(activeCssClass);
        $(this).buttonsCollapsed();
      });
  };

  $.fn.buttonsExpanded = function (): JQuery<HTMLElement> {
    return $(this)
      .children()
      .children(expandSubMenuButtonSelector)
      .each(function () {
        $(this).attr("aria-expanded", "true");
      });
  };

  $.fn.buttonsCollapsed = function (): JQuery<HTMLElement> {
    return $(this)
      .children()
      .children(expandSubMenuButtonSelector)
      .each(function () {
        $(this).attr("aria-expanded", "false");
      });
  };

  // Function with action on expandable header background
  $.fn.restoreHeight = function (): JQuery<HTMLElement> {
    let newHeight: number = 0;

    if ($header.hasClass(headerSearchIsOpen)) {
      const height = $searchMain.outerHeight();
      if (height) newHeight = height;
    }

    if (useDesktopMenu) {
      $menuWrappers.has(":visible").each(function () {
        // Reset the heights:
        $(this).height("");

        if ($(this).hasClass(level2wrapperCssClass)) {
          const itemHeight = $(this).outerHeight();
          if (itemHeight && itemHeight > newHeight) newHeight = itemHeight;
        }

        if ($(this).hasClass(level3wrapperCssClass)) {
          $(this)
            .find(`.${level3itemsCssClass}`)
            .each(function () {
              const itemHeight = $(this).outerHeight();
              if (itemHeight && itemHeight > newHeight) newHeight = itemHeight;
            });
        }
      });

      // Set the heights of the menu items
      $menuWrappers.has(":visible").each(function () {
        $(this).height(newHeight);
      });
    }

    $(this).height(newHeight);

    return $(this);
  };

  return {
    init,
  };
})();

export default Menu;
